import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type FAQItem = {
  question: string;
  answer: string;
};
type FAQAccordionProps = {
  items: FAQItem[];
};
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="space-y-3" data-id="element-1">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className="border border-teal-200 rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-2">
            <button onClick={() => toggle(index)} className="w-full flex items-center justify-between px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500" aria-expanded={isOpen} data-id="element-3">
              <span className="font-heading font-700 text-base md:text-lg text-slate-800 pr-4 font-bold" data-id="element-4">
                {item.question}
              </span>
              <ChevronDownIcon className={`flex-shrink-0 w-5 h-5 text-teal-600 transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`} data-id="element-5" />
            </button>
            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-6">
              <div className="px-6 pb-5 text-slate-600 leading-relaxed border-t border-teal-100 pt-4" data-id="element-7">
                {item.answer}
              </div>
            </div>
          </div>;
    })}
    </div>;
}